import { render, staticRenderFns } from "./game-page.vue?vue&type=template&id=91e130b2&scoped=true&"
import script from "./game-page.vue?vue&type=script&lang=js&"
export * from "./game-page.vue?vue&type=script&lang=js&"
import style0 from "./game-page.vue?vue&type=style&index=0&id=91e130b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e130b2",
  null
  
)

export default component.exports